const baseStyle = {
  fontWeight: 'semibold',
}

const sizes = {
  '5xl': {
    fontSize: '7xl',
    lineHeight: '5.625rem',
    letterSpacing: 'tight',
  },
  '4xl': {
    fontSize: '6xl',
    lineHeight: '4.5rem',
    letterSpacing: 'tight',
  },
  '3xl': {
    fontSize: '5xl',
    lineHeight: '3.75rem',
    letterSpacing: 'tight',
  },
  '2xl': {
    fontSize: '4xl',
    lineHeight: '2.75rem',
    letterSpacing: 'tight',
  },
  xl: {
    fontSize: '3xl',
    lineHeight: '2.375rem',
  },
  lg: {
    fontSize: '2xl',
    lineHeight: '2rem',
  },
  md: {
    fontSize: 'xl',
    lineHeight: '1.75rem',
  },
  sm: {
    fontSize: 'lg',
    lineHeight: '1.625rem',
  },
  xs: {
    fontSize: 'md',
    lineHeight: '1.375rem',
  },
}

export default {
  baseStyle,
  sizes,
}
